import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/favicon.ico"
// import logoLightPng from "../../assets/images/logo-light.png"
import logoLightSvg from "../../assets/images/favicon.ico"
// import logoDark from "../../assets/images/logo-dark.png"

function tAdd() {
  var body = document.body
  // body.classList.add("vertical-collpsed")
  // body.classList.add("sidebar-enable")
}

const Sidebar = props => {
    useEffect(()=>{
      tAdd()
    },[])
  return (
    <React.Fragment>
      <div
        className="vertical-menu newnav" style={{position:"fixed"}}>
        <div className="navbar-brand-box">
          <Link to="#" className="logo logo-dark">
            <span className="logo-sm">
              <img loading="lazy"  src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logoLightSvg} alt="" height="60" />
            </span>
          </Link>

          <Link to="#" className="logo logo-light">
            <span className="logo-sm">
              <img loading="lazy" src={logoLightSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logoLightSvg} alt="" height="60" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
